import { useBulkSendStatusNotifier } from './useBulkSendStatusNotifier';

const BulkSendStatusNotifier = () => {
  useBulkSendStatusNotifier();

  return null;
};

export default BulkSendStatusNotifier;
